export const fr = {
  causes: {
    harm_reduction: 'Réduction des méfaits',
    crisis_support: 'Soutien en situation de crise',
    advocacy_and_human_rights: 'Plaidoyer et droits humains',
    health_and_medecine: 'Santé et médecine',
    homeless_and_housing: 'Itinérance et logement',
    family_support: 'Soutien familial',
    employment_and_mentorship: 'Emploi et mentorat',
    disaster_and_emergency: 'Catastrophes et urgences',
    international_development: 'Développement international',
    food_security: 'Sécurité alimentaire',
    community: 'Communauté',
    bipoc: 'PANDC',
    justice_and_legal: 'Justice et droit',
    women: 'Femmes',
    stem: 'STIM',
    sports_and_recreation: 'Sports et loisirs',
    seniors: 'Aînés',
    mental_health: 'Santé mentale',
    lgbtq: 'LGBTQ+',
    immigrants_and_refugees: 'Immigrants et réfugiés',
    environment: 'Environnement',
    education: 'Éducation',
    disabilities: 'Handicaps',
    children_and_youth: 'Enfants et jeunesse',
    board_development: 'Développement du conseil',
    arts_and_culture: 'Arts et culture',
    animals: 'Animaux',
  },
}